import ContentLayout from '@/layouts/content-layout'
import ClipsView from '@/sections/clips/view/clips-view'

export default function ClipsPage() {
  return (
    <ContentLayout title="คลิป">
      <ClipsView />
    </ContentLayout>
  )
}
